import queryString from 'query-string';
import {isEmpty} from 'lodash';

interface optionsProps{
  url?: string;
  onConnect?: Function;
  onDisconnect?: Function;
  onMessage?: Function;
  queryParams?: object;
}

const getHost = () => {
  const { hostname } = window.location;
  if (hostname.indexOf('localhost') > -1) {
    return 'dev.gotrova.ai'
  }
  return hostname;
}

const wsClient = (options:optionsProps) => {
  let { url } = options;
  if (!url) {
    console.error('Provide websocket URL to connect to');
    return;
  }
  url = `wss://${getHost()}/gateway/api/${url}`
  if (options.queryParams && !isEmpty(options.queryParams)) {
    url = `${url}?${queryString.stringify(options.queryParams)}`
  }
  let client = new WebSocket(url);

  client.addEventListener("open", () => {
    console.log(`[websockets] Connected to ${options.url}`);
    if (options.onConnect) {
      options.onConnect()
    }
  });

  client.addEventListener("close", () => {
    console.log(`[websockets] Disconnected from ${options.url}`);
    //@ts-ignore
    client = null;
    if (options.onDisconnect) {
      options.onDisconnect()
    }
  });

  client.addEventListener('message', (ev) => {
    if (ev?.data && options.onMessage) {
      options.onMessage(JSON.parse(ev.data));
    }
  })

  const connection = {
    client,
    send: (message = {}) => {
      if (options.queryParams) {
        message = { ...message, ...options.queryParams };
      }
      return client.send(JSON.stringify(message));
    }
  }

  return connection;
}

export default wsClient;